export const TABLE_DEFAULT_RESULT_PER_PAGE = 10
export const TABLE_USERS_EXPORTED_LIMIT = 1000
export const TAB_USER = 'users'
export const TAB_ORGANISATION = 'organisations'
export const TAB_MESSAGES = 'messages'
export const TAB_CONTRATS = 'contrats'
export const TAB_DOCUMENTS = 'documents'
export const TAB_BILL = 'bill'
export const TAB_CREDIT = 'credit'
export const TAB_BRM = 'brm'
export const TAB_COMMUNICATIONS = 'communications'
export const TAB_NOTIFICATIONS = 'notifications'
export const TAB_MAINTENANCE_HISTORY = 'maintenanceHistory'
export const TIME_OUT_TABLE = 29999
